import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from './plugins/vuetify';
import { SPECIES } from './global';
import api from './api';

const LOGIN = 'LOGIN';

const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
const SHIFT_NOTIFICATION = 'SHIFT_NOTIFICATION';

const TOGGLE_THEME = 'TOGGLE_THEME';

const UPDATE_SPECIES = 'UPDATE_SPECIES';
const UPDATE_GENES = 'UPDATE_GENES';
const TOGGLE_SEQUENCE = 'TOGGLE_SEQUENCE';
const UPDATE_SEQUENCE = 'UPDATE_SEQUENCE';

const INIT_GRID = 'INIT_GRID';
const UPDATE_SELECTED_ROWS = 'UPDATE_SELECTED_ROWS';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isPublic: null,
    darkTheme: JSON.parse(localStorage.getItem('darkTheme') || '{}') === true,
    error: null,
    notificationQueue: [],
    lastNotification: null,
    species: [ ...SPECIES ],
    filter: {
      species: 'hg38',
      genes: [],
      sequence: false,
      sequenceText: ''
    },
    grid: {
      api: null,
      selectedRows: []
    }
  },
  getters: {
    hasNotificationsPending: state => {
      return state.notificationQueue.length > 0
    },

    isFilterEnabled: state => ((state.filter.species !== null) &&
        ((!state.filter.sequence && state.filter.genes.length > 0) || (state.filter.sequence && state.filter.sequenceText !== '')))
  },
  mutations: {
    [LOGIN]: (state, result) => state.isPublic = result,

    [ADD_NOTIFICATION]: (state, notification) => {
      if (!state.lastNotification || (state.lastNotification.text !== notification.text && state.lastNotification.type !== notification.text)) {
        state.lastNotification = notification;
        state.notificationQueue.push(notification);
      }
    },
    [SHIFT_NOTIFICATION]: state => {
      state.notificationQueue.shift();
      if (state.notificationQueue.length === 0) {
        setTimeout(() => state.lastNotification = null, 5000);
      }
    },

    [TOGGLE_THEME]: state => {
      state.darkTheme = !state.darkTheme;
      Vuetify.framework.theme.dark = state.darkTheme;
      localStorage.setItem('darkTheme', state.darkTheme.toString());
    },

    [UPDATE_SPECIES]: (state, species) => state.filter = { ...state.filter, species },
    [UPDATE_GENES]: (state, genes) => state.filter = { ...state.filter, genes },
    [TOGGLE_SEQUENCE]: (state, sequence) => state.filter = { ...state.filter, sequence },
    [UPDATE_SEQUENCE]: (state, sequenceText) => state.filter = { ...state.filter, sequenceText },

    [INIT_GRID]: (state, api) => state.grid = { ...state.grid, api },
    [UPDATE_SELECTED_ROWS]: (state, selectedRows) => state.grid = { ...state.grid, selectedRows }
  },
  actions: {
    login: async ({ commit }, password) => {
      try {
        await api.login(password);
        commit(LOGIN, true);
      } catch (e) {
        commit(LOGIN, false);
        throw new Error(e)
      }
    },
    addNotification: ({ commit }, notification) => commit(ADD_NOTIFICATION, notification),
    shiftNotification: ({ commit, state }) => {
      const notification = state.notificationQueue[0];
      commit(SHIFT_NOTIFICATION);
      return notification;
    },

    updateSpecies: ({ commit }, species) => commit(UPDATE_SPECIES, species),
    updateGenes: ({ commit }, genes) => commit(UPDATE_GENES, genes),
    toggleSequence: ({ commit }, sequence) => commit(TOGGLE_SEQUENCE, sequence),
    updateSequence: ({ commit }, sequenceText) => commit(UPDATE_SEQUENCE, sequenceText),

    initGrid: ({ commit }, api) => commit(INIT_GRID, api),
    updateSelectedRows: ({ commit }, selectedRows) => commit(UPDATE_SELECTED_ROWS, selectedRows)
  }
});
